import moment from 'moment';
import 'moment/locale/es';
import { fetchFromObject, setValueObjectByField } from 'helpers/object';

moment.locale('es');

const DATE_FORMAT_DEFAULT = 'DD/MM/YYYY';
const DATE_TIME_FORMAT_DEFAULT = 'DD/MM/YYYY HH:mm';
const DATE_FORMAT_ISO = 'YYYY-MM-DDTHH:mm:ss';
const DATE_FORMAT_ISO_WITHOUT_SECONDS = 'YYYY-MM-DDTHH:mm';
const DATE_FORMAT_BBVA = 'YYYY-MM-DD';

export const dateToday = (format = null) => (!format ? moment() : moment().format(format));

export const dateTodayIso = ({ withoutSeconds = false }) =>
  dateToday(withoutSeconds ? DATE_FORMAT_ISO_WITHOUT_SECONDS : DATE_FORMAT_ISO);

// Dates format
export const dateToString = (val, format = DATE_FORMAT_DEFAULT) =>
  val ? moment(val).format(format) : '';

export const dateTimeToString = (val, format = DATE_TIME_FORMAT_DEFAULT) =>
  val ? moment(val).format(format) : '';

export const stringToDate = (val, format = DATE_FORMAT_DEFAULT) => moment(val, format);

export const dateToISO = (val, format = DATE_FORMAT_DEFAULT) =>
  val ? moment(val, format).format(DATE_FORMAT_ISO) : '';

export const changeFormatFromBBVA = val =>
  moment(val, DATE_FORMAT_BBVA).format(DATE_FORMAT_DEFAULT);

export const adjustDateToValidate = (ISODate, days) => {
  const newDate = new Date(ISODate);
  newDate.setDate(newDate.getDate() + days);
  return newDate.toLocaleDateString('en-GB');
};

/**
 * Adds current date to object when path value is null.
 * @param {Object} data
 * @param {String} prop
 * @param {String} format
 * @return {Object} data
 */
export const setCurrentDateTimeIfNull = ({
  data,
  prop,
  format = DATE_FORMAT_ISO_WITHOUT_SECONDS
}) => {
  const defaultDate = fetchFromObject(data, prop);
  const today = dateToday(format);
  if (!defaultDate || defaultDate === '01/01/0001') {
    setValueObjectByField(data, prop, today);
  }
  return data;
};
